<template>
  <div id="app">

    <div id="escalaGrisesFuncion">
      <nav-gob></nav-gob>
      <nav-hacienda></nav-hacienda>
      <router-view style="min-height: 85vh !important;"></router-view>
    </div>

    <footer-component></footer-component>
  </div>
</template>

<script>
import navGob from '@/views/Nav-gob.vue'
import navHacienda from '@/views/Nav-hacienda.vue'
import footerComponent from '@/views/Footer-component.vue'

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  components: {
    navGob,
    navHacienda,
    footerComponent,
  }
}

</script>
